export enum ActionStatus {
    Actionable,
    NotActionable,
    Unavailable
}
